import { useEffect, useState } from 'react';

import { Text } from '../Text';

import { LoadingIcon } from './LoadingIcon';

import styles from './pageLoading.css';

export const loadingTexts = [
  'Loading data (1/5)',
  'Loading data (2/5)',
  'Loading data (3/5)',
  'Loading data (4/5)',
  'Loading data (5/5)',
];

const defaultLoadingTime = 10000;

type Props = {
  text?: string[];
  estimatedLoadingTime?: number;
};

export const PageLoading = ({ text, estimatedLoadingTime }: Props) => {
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(
      () => {
        setTextIndex((prevIndex) => prevIndex + 1);
      },
      (estimatedLoadingTime || defaultLoadingTime) / (text ? text.length : 1),
    );

    return () => clearInterval(interval);
  }, [estimatedLoadingTime, text]);

  return (
    <div className={styles.container} role="status" aria-hidden="false" aria-label="Loading">
      <div className={styles.svg}>
        <LoadingIcon />
      </div>
      {text ? (
        <Text variant="meta">{textIndex < text.length ? text[textIndex] : 'Getting things ready...'}</Text>
      ) : (
        <Text variant="meta">&nbsp;</Text>
      )}
    </div>
  );
};
